/**
 *-------------------------------------------
 * create SignUpClientActions actions in redux
 *-------------------------------------------
 */

import * as SignUpClientActions from '../constants/signUpClient'

export const fetch_sign_up_client_request = () => {
    return {
        type: SignUpClientActions.FETCH_SIGN_UP_CLIENT_REQUEST
    }
}

export const fetch_sign_up_client_success = (signUpClientData) => {
    return {
        type: SignUpClientActions.FETCH_SIGN_UP_CLIENT_SUCCESS,
        signUpClientData
    }
}

export const fetch_sign_up_client_failure = (error) => {
    return {
        type: SignUpClientActions.FETCH_SIGN_UP_CLIENT_FAILURE,
        error
    }
}

export const sign_up_client_reset = () => {
    return {
        type: SignUpClientActions.SIGN_UP_CLIENT_RESET
    }
}
